// client/src/components/dashboard/Dashboard.js
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from '../common/LoadingSpinner';
import Sidebar from './sidebar/Sidebar';
import DashboardContent from './main/DashboardContent.js';
import AccountPage from './account/AccountPage.js';
import ManageProperties from './Properties/ManageProperties';
import ManageDevices from './devices/ManageDevices';
import SettingsPage from './settings/SettingsPage.js';
import ServicesPage from '../pages/services/ServicesPage.js';
import ProductsPage from '../pages/products/ProductsPage.js';
import BlogPage from '../pages/blog/BlogPage.js';
import AboutPage from '../pages/about/AboutPage.js';
import ContactPage from '../pages/contact/ContactPage.js';
import PrivacyPolicyPage from '../agreements/PrivacyPolicyPage';
import CookiesPolicyPage from '../agreements/CookiesPolicyPage';
import UserAgreementPage from '../agreements/UserAgreementPage';
import { useTranslation } from 'react-i18next'; // Import

import './Dashboard.css';

function Dashboard() {
    const { logout, user, loading } = useAuth();
    // console.log('[DashBoardPage] Rendering - Loading:', loading, 'User:', user);
    const location = useLocation();
    const from = location.state?.from?.pathname || '/login';

    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [activeSection, setActiveSection] = useState('dashboard'); // Add activeSection state
    const { t } = useTranslation(); // Add this line


    useEffect(() => {
        const fetchUserData = async () => {
            try {
                if (!user) {
                    setError(t('dashboard.errors.noUserData')); // Use translation
                    return;
                }
            } catch (error) {
                console.error("Error fetching user data:", error);
                if (error.response && error.response.status === 401) {
                    // Unauthorized - clear user and redirect to login
                    await logout();
                    navigate('/login', { replace: true });

                } else {
                    setError(t('dashboard.errors.fetchError')); // Use translation
                }
            }
        };

        fetchUserData();
    }, [logout, navigate, user, t]); // Add 't' to dependencies

    // Function to handle clicks on sidebar links
    const handleSectionChange = (section) => {
        setActiveSection(section);
    };

    // Show loading spinner while context might be initializing
    if (loading) {
        console.log('[DashBoardPage] Showing LoadingSpinner because loading is true');
        return <LoadingSpinner />;
    }

    // Redirect if loading is done and user exists
    if (!user) {
        console.log('[DashBoardPage] User exists, redirecting to:', from);
        return <Navigate to={from} replace />;
    }


    return (
        <div>
            <div className="dashboard-container">
                <Sidebar onSectionChange={handleSectionChange} activeSection={activeSection} /> {/* Pass props */}
                <div className="dashboard-content">
                    {error && <p>Error: {error}</p>}
                    {/* Conditionally render content based on activeSection */}
                    {activeSection === 'dashboard' && (<DashboardContent />)}
                    {activeSection === 'account' && <AccountPage />}
                    {activeSection === 'properties' && <ManageProperties />}
                    {activeSection === 'devices' && <ManageDevices />}
                    {activeSection === 'settings' && <SettingsPage />}
                    {activeSection === 'services' && <ServicesPage />}
                    {activeSection === 'products' && <ProductsPage />}
                    {activeSection === 'blog' && <BlogPage />}
                    {activeSection === 'about' && <AboutPage />}
                    {activeSection === "contact" && <ContactPage />}
                    {activeSection === 'privacy' && <PrivacyPolicyPage />}
                    {activeSection === 'cookies' && <CookiesPolicyPage />}
                    {activeSection === 'agreement' && <UserAgreementPage />}
                </div>
            </div>
        </div>
    );
}

export default Dashboard;